var map = {
	"./Capitol_UnflippedTile_a.webp": 2486,
	"./Capitol_flippedTile_a.webp": 4126,
	"./Capitol_flippedTile_b.webp": 3780,
	"./Capitol_unflippedTile_b.webp": 7636,
	"./Cymbidium_UnflippedTile_a.webp": 1385,
	"./Cymbidium_UnflippedTile_b.webp": 2923,
	"./Cymbidium_flippedTile_a.webp": 2799,
	"./Cymbidium_flippedTile_b.webp": 9516,
	"./Phlox_flippedTile_b.webp": 8001,
	"./Saffron_UnflippedTile_.webp": 1053
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62;